// Global Types
import type {
  $FullRegattaEntry,
  $RegattaEntryResource,
} from 'common.data';

// Global Components
import * as React from 'react';

// Helpers
import {
  getRegattaEntrySubTitle,
  getRegattaEntryTitle,
  shortenText,
} from 'common.helpers/dist/browser';

// Types
type $OptionalProps = {
  shorten?: boolean;
  showAge?: boolean;
};

type $Props = $OptionalProps & {
  bowNoEnabled: boolean;
  countryEnabled: boolean;
  item: $FullRegattaEntry | $RegattaEntryResource;
};

const RegattaEntryView = function ({
  bowNoEnabled,
  countryEnabled,
  item,
  shorten,
  showAge,
}: $Props) {
  const regattaEntryTitle = getRegattaEntryTitle({
    bowNoEnabled,
    countryEnabled,
    regattaEntry: item,
  });

  const regattaEntrySubTitle = getRegattaEntrySubTitle({
    countryEnabled,
    regattaEntry: item,
    showAge,
  });

  return (
    <div className={'lh-1'}>
      <div title={regattaEntryTitle}>
        {shorten === true ? shortenText(
          regattaEntryTitle,
          25,
        ) : regattaEntryTitle}
      </div>
      <small
        className={'text-muted'}
        title={regattaEntrySubTitle}
      >
        {shorten === true ? shortenText(
          regattaEntrySubTitle,
          27,
        ) : regattaEntrySubTitle}
      </small>
    </div>
  );
};

RegattaEntryView.defaultProps = {
  shorten: undefined,
  showAge: undefined,
};

export default RegattaEntryView;
